/* eslint-disable camelcase */
import type {ApprovalCreateRequest, ApprovalType, ApprovalView} from '@api/approval/api.d';

type SignatureField = Partial<Pick<ApprovalView, 'width' | 'height' | 'page' | 'top' | 'left' | 'font_size'>> & {
    signing_type?: string;
    extractAnchor?: boolean;
};

interface ApprovalRequestParams {
    recipient_id: string;
    is_optional?: boolean;
    signatureField: SignatureField;
    name?: string;
    deprecated_id?: string;
}

type DesignerApprovalCreateRequest = ApprovalCreateRequest & {
    deprecated_id?: string;
};

export function buildApprovalRequest({
    recipient_id, is_optional, signatureField, name, deprecated_id
}: ApprovalRequestParams): DesignerApprovalCreateRequest {
    let signing_type: string = signatureField.signing_type || 'signature';

    const hasNoCoords = !signatureField.extractAnchor && (
        !signatureField.width || !signatureField.height
    );
    if (hasNoCoords) {
        signing_type = 'accept';
    }

    const body: DesignerApprovalCreateRequest = {
        recipient_id,
        font_family_id: 'string',
        signing_type: signing_type as ApprovalType,
        page: signatureField.page ?? 0,
        top: signatureField.top || 0,
        left: signatureField.left || 0,
        width: signatureField.width || 0,
        height: signatureField.height || 0,
        font_size: signatureField.font_size ?? 10,
        is_optional: Boolean(is_optional)
    };

    if (name && name.trim()) body.name = name;
    if (deprecated_id) body.deprecated_id = deprecated_id;

    return body;
}
